<form nz-form [formGroup]="formGroup" (ngSubmit)="submit()">

  <app-attribute-base-info
  [languageId]="languageId"
  [formGroup]="formGroup" 
  [hasUomAttribute]="hasUomAttribute" [mode]="mode"
   [record]="record"
    (hasUomChanged)="hasUomAttribute = $event">
  </app-attribute-base-info>
  
  <nz-row *ngIf="hasUomAttribute">
    <nz-col nzSpan="24">
      <div class="page-content-section" style="padding: 10px">
        <app-attribute-uom
        [formGroup]="formGroup"
          [units]="uoms"
          [attributeId]="record != undefined ? record.Id : 0"
          (onUnitsChange)="onUnitsChange($event)"
        ></app-attribute-uom>
      </div>
    </nz-col>
  </nz-row>
  <nz-row *ngIf="RelatedObjectType.value === 12">
    <nz-col nzSpan="24" style="margin-top: 24px;">
      <div class="page-content-section">
        <fieldset>
          <legend>{{'Attribute Groups'  | translate}}</legend>
          
          <div [formGroup]="formSearch"  class="search-container">
            <input
              nz-input
              [placeholder]="'Search for attribute sets...'  | translate"
              [formControl]="searchQueryControl"
            />
            <i class="search-icon" nz-icon nzType="search"></i>
          </div>
 
         <nz-table
          #table
          nzShowPagination
          [nzData]="paginatedData"
          [nzFrontPagination]="false"
          [nzTotal]="totalItems"
          [nzPageIndex]="currentPage"
          [nzPageSize]="pageSize"
          (nzPageIndexChange)="onPageChange($event)"
        
         >
          <thead>
            <tr>
              <th>{{'Attribute Set'  | translate}}</th>
              <th>{{'Attribute Group'  | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let set of paginatedData">
              <td>{{ set.Name }}</td>
              <td>
                <nz-select  [nzAllowClear]="true" style="width: 100%" [ngModel]="selectedGroups[set.Id]"
                  [ngModelOptions]="{ standalone: true }" 
                  (ngModelChange)="selectedGroupsChange($event, set.Id)">
                  <nz-option *ngFor="let group of set.AttributeGroups" [nzValue]="group.Id" [nzLabel]="group.Name"></nz-option>
                </nz-select>
              </td>
            </tr>
          </tbody>
         </nz-table>
        </fieldset>
      </div>
    </nz-col>
  </nz-row>
  <nz-row>
    <nz-col nzSpan="24">
      <app-attribute-type [formGroup]="formGroup" [mode]="mode" 
      [listOfOptions]="listOfOptions"
        (optionsChanged)="attributeOptionsChanged($event)"></app-attribute-type>
    </nz-col>
    <nz-col nzSpan="24" nzFlex *ngIf="
        formGroup &&
        formGroup.get('Id') != null &&
        formGroup.get('Id')!.value !== 0
      ">
      <div class="page-content-section">
        <app-attribute-default-value [formGroup]="formGroup" [options]="listOfOptions"></app-attribute-default-value>
      </div>
    </nz-col>
    <nz-col nzSpan="24" *ngIf="Type.valid && validators.length > 0">
      <div class="page-content-section options-panel">
        <app-attribute-validators [formGroup]="formGroup" [validators]="validators"
          formArrayName="AttributeValidators"></app-attribute-validators>
      </div>
    </nz-col>
  </nz-row>

  <ng-container *ngIf="formGroup.value['Type'] === '8'">
    <nz-row class="page-content-section options-panel">
      <fieldset style="width: 100%">
        <legend>{{'Object Type'  | translate}}</legend>
        <nz-select style="width: 100%" formControlName="RelationObjectType">
          <nz-option *ngFor="let type of objectTypes" [nzValue]="type.Code" [nzLabel]="type.Label"></nz-option>
        </nz-select>
      </fieldset>
    </nz-row>
  </ng-container>
  <app-custom-attributes [objectTypeId]="1" [isBulkEdit]="false" [record]="record"
    formGroupName="AttributeValueObjectNavigations">
  </app-custom-attributes>
</form>

<div class="child-attributes page-content-section" *ngIf="Type.valid && Name.valid">
  <app-attribute-children [formGroup]="formGroup" [existedChildAttributes]="existedChildAttributes"
    [childAttributesToAdd]="childAttributesToAdd"
    (childAttributesChanged)="childAttributesToAdd = $event"></app-attribute-children>
</div>
